import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { clamp, cycleClamp } from "../../../../utils/math";
import { FrameSwitcherView } from "./View";

/**
 * This component extends `FrameSwitcherView` and add control functions to control scroll position
 * @class
 * @augments FrameSwitcherView
 */
export var FrameSwitcherControl = /*#__PURE__*/function (_FrameSwitcherView) {
  _inherits(FrameSwitcherControl, _FrameSwitcherView);
  var _super = _createSuper(FrameSwitcherControl);
  function FrameSwitcherControl(props) {
    var _this;
    _classCallCheck(this, FrameSwitcherControl);
    _this = _super.call(this, props);
    /**
     * Calculate end frame index and delta to move to end frame for non-cycle switch
     * @param {number} delta Direction and amount of frames to scroll throught
     */
    _defineProperty(_assertThisInitialized(_this), "intervalChangeFrame", function (delta) {
      var clampFn = clamp(_this.props.frames.length - _this.props.framesPerSlide, 0);
      var target = clampFn(_this.state.activeFrame + delta);
      var moveDistance = target * _this.moveFactor;
      return {
        frame: target,
        moveDistance: moveDistance
      };
    });
    /**
     * Calculate end frame index and delta to move to end frame for cycle switch
     * @param {number} delta Direction and amount of frames to scroll throught
     */
    _defineProperty(_assertThisInitialized(_this), "cycleChangeFrame", function (delta) {
      var target = _this.clampFn(_this.props.frames.length, 0)(_this.state.activeFrame + delta);
      return {
        frame: target,
        moveDistance: (delta + _this.state.activeFrame) * _this.moveFactor
      };
    });
    _this.showLeft = _this.showLeft.bind(_assertThisInitialized(_this));
    _this.showRight = _this.showRight.bind(_assertThisInitialized(_this));
    _this.showSlide = _this.showSlide.bind(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * Shorthand for scroll position of frames
   * @type {number}
   */
  _createClass(FrameSwitcherControl, [{
    key: "scroll",
    get: function get() {
      return this.content && this.content.scrollLeft || 0;
    }

    /**
     * Shorthand for clamping function. It depends on `cycle` prop
     * @type {(max: number, min: number = 0) => (value: number) => number}
     */
  }, {
    key: "clampFn",
    get: function get() {
      return this.props.cycle ? cycleClamp : clamp;
    }

    /**
     * Distance (in px) between start of 2 frames
     */
  }, {
    key: "moveFactor",
    get: function get() {
      return this.props.frameWidth + this.props.gutter;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      _get(_getPrototypeOf(FrameSwitcherControl.prototype), "componentDidMount", this).call(this);
      requestAnimationFrame(function () {
        if (_this2.content && _this2.scroll === 0) {
          _this2.scrollTo(_this2.props.placeholderWidth);
        }
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var _this3 = this;
      requestAnimationFrame(function () {
        var currentPos = (_this3.scroll - _this3.props.placeholderWidth) / _this3.moveFactor;
        _this3.scrollTo(props.placeholderWidth + currentPos * (props.frameWidth + props.gutter));
      });
    }

    /**
     * Abstract function to move scroll to position.
     * @param {number} position End position to move to
     */
  }, {
    key: "moveTo",
    value: function moveTo(position) {
      return this.scrollTo(position);
    }

    /**
     * Abstract function to move scroll by delta.
     * @param {number} delta Amount of px to move scroll
     */
  }, {
    key: "moveBy",
    value: function moveBy(delta) {
      return this.scrollBy(delta);
    }

    /**
     * Simply set scroll value
     * @param {number} value Position to set scroll
     */
  }, {
    key: "scrollTo",
    value: function scrollTo(value) {
      this.content.scrollLeft = value;
      return Promise.resolve();
    }

    /**
     * Change scroll by value
     * @param {number} value Amount of px to change scroll value
     */
  }, {
    key: "scrollBy",
    value: function scrollBy(value) {
      this.scrollTo(this.scroll + value);
      return Promise.resolve();
    }

    /**
     * Set `activeFrame` state value. It also execute `onSwitchStart` props hook
     * @param {number} activeFrame Index of active frame to set
     */
  }, {
    key: "setActiveFrame",
    value: function setActiveFrame(activeFrame) {
      if (this.state.activeFrame !== activeFrame) {
        this.props.onSwitchStart(activeFrame);
        this.setState({
          activeFrame: activeFrame
        });
      }
    }

    /**
     * Switches frame by delta. It uses `this.move` function to change frame.
     * @param {number} delta Direction and amount of frames to scroll throught
     */
  }, {
    key: "changeFrame",
    value: function changeFrame(delta) {
      if (delta === 0) {
        return Promise.resolve();
      }
      var changeFn = this.props.cycle ? this.cycleChangeFrame : this.intervalChangeFrame;
      var _changeFn = changeFn(delta),
        frame = _changeFn.frame,
        moveDistance = _changeFn.moveDistance;
      this.setActiveFrame(frame);
      return this.moveTo(moveDistance + this.props.placeholderWidth);
    }
  }, {
    key: "showSlide",
    value:
    /**
     * Switch to frame
     * @param {number} slide Index of frame to show
     */
    function showSlide(slide) {
      // used by Switch
      this.stopAutoSwitch();
      var slideId = this.clampFn(this.props.frames.length, 0)(slide);
      this.changeFrame(slideId - this.state.activeFrame);
    }

    /**
     * Switch frame to left by `framesPerSlide` prop value
     */
  }, {
    key: "showLeft",
    value: function showLeft() {
      // used by Arrow
      this.stopAutoSwitch();
      return this.changeFrame(-this.props.step);
    }

    /**
     * Switch frame to right by `framesPerSlide` prop value
     */
  }, {
    key: "showRight",
    value: function showRight() {
      // used by Arrow
      this.stopAutoSwitch();
      return this.changeFrame(this.props.step);
    }

    /**
     * Calculate frame index of current scroll position
     */
  }, {
    key: "getFrameUnderScrollPosition",
    value: function getFrameUnderScrollPosition() {
      var _this$props = this.props,
        frames = _this$props.frames,
        cycle = _this$props.cycle,
        framesPerSlide = _this$props.framesPerSlide,
        adjustmentDisplaceRatio = _this$props.adjustmentDisplaceRatio;
      var start = this.props.placeholderWidth - this.moveFactor * adjustmentDisplaceRatio;
      var maxFrame = frames.length - (cycle ? 0 : framesPerSlide);
      var end = maxFrame * this.moveFactor + start;
      var clampFn = this.clampFn(end, start);
      return Math.floor((clampFn(this.scroll) - start) / this.moveFactor);
    }
  }]);
  return FrameSwitcherControl;
}(FrameSwitcherView);